<div class="dashboard-content" style="padding: 120px 40px 50px">
  <div class="billing-and-payments-screen">
    <div class="page-heading">
      <h3>{{ 'activity-logs.title' | translate }}</h3>
      <div class="heading-right">
        <div class="search">
          <input type="text" class="form-control" [placeholder]="'activity-logs.search-placeholder' | translate" [(ngModel)]="searchTerm"
            (input)="onSearchChange()" autocapitalize="off" style="text-transform: none;">
          <i class="fa-solid fa-magnifying-glass" style="cursor: pointer;"></i>
          <i class="fa-solid fa-xmark clear-search" *ngIf="searchTerm" (click)="searchTerm = ''; onSearchChange()"
            style="cursor: pointer;"></i>
        </div>
        <button class="btn btn-light filter-btn" (click)="openFilterModal()">
          <i class="fa-solid fa-filter"></i>
          <span>{{ 'common.filter' | translate }}</span>
          <span *ngIf="hasActiveFilters()" class="filter-active-dot"
            (click)="clearFilters(); $event.stopPropagation()" title="{{ 'common.clear-filters-tooltip' | translate }}">
          </span>
        </button>
        <button class="btn btn-light filter-btn" (click)="exportCsv()">
          <i class="fa-solid fa-file-csv"></i>
          <span>{{ 'common.export' | translate }} CSV</span>
        </button>
      </div>
    </div>

    <!-- Logs Table -->
    <div class="luqta-card">
      <div class="card-heading">
        <h3>{{ 'activity-logs.title' | translate }} ({{ totalLogs }})</h3>
      </div>

      <nz-table #logsTable [nzData]="logs" [nzBordered]="true" [nzScroll]="{ x: '1400px' }"
        [nzFrontPagination]="false" [nzPageSize]="perPage" [nzShowSizeChanger]="true"
        [nzPageSizeOptions]="[10, 20, 50, 100]" [nzShowPagination]="true" [nzPageIndex]="currentPage"
        [nzTotal]="totalLogs" (nzPageSizeChange)="onPageSizeChange($event)"
        (nzPageIndexChange)="onPageIndexChange($event)">
        <thead>
          <tr>
            <th nzWidth="50px">#</th>
            <th nzWidth="180px">{{ 'activity-logs.date-time' | translate }}</th>
            <th nzWidth="140px">{{ 'activity-logs.category' | translate }}</th>
            <th nzWidth="120px">{{ 'activity-logs.action' | translate }}</th>
            <th nzWidth="110px">{{ 'activity-logs.severity' | translate }}</th>
            <th nzWidth="300px">{{ 'activity-logs.description' | translate }}</th>
            <th nzWidth="180px">{{ 'activity-logs.content' | translate }}</th>
            <th nzWidth="80px" nzRight>{{ 'activity-logs.details' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let log of logsTable.data; let i = index">
            <td>{{ (currentPage - 1) * perPage + i + 1 }}</td>
            <td>{{ formatDateTime(log.created_at) }}</td>
            <td>
              <span class="category-badge" [ngClass]="getCategoryClass(log.category)">
                {{ getCategoryLabel(log.category) }}
              </span>
            </td>
            <td>
              <span class="action-text">{{ getActionLabel(log.action) }}</span>
            </td>
            <td>
              <span class="severity-badge" [ngClass]="getSeverityClass(log.severity)">
                {{ getSeverityLabel(log.severity) }}
              </span>
            </td>
            <td>
              <span [title]="log.description">
                {{ (log.description || '').length > 60 ? (log.description | slice:0:60) + '...' : log.description || '-' }}
              </span>
            </td>
            <td>
              <span [title]="log.content_title">
                {{ log.content_type ? log.content_type + ': ' : '' }}{{ log.content_title || '-' }}
              </span>
            </td>
            <td nzRight>
              <svg (click)="openDetailDrawer(log)" width="18" height="18" viewBox="0 0 18 18" fill="none"
                xmlns="http://www.w3.org/2000/svg" nz-tooltip [nzTooltipTitle]="'activity-logs.view-details' | translate"
                style="cursor: pointer;">
                <mask id="mask0_activity_log" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"
                  style="mask-type: alpha;">
                  <rect width="17.7778" height="17.7778" fill="#D9D9D9"></rect>
                </mask>
                <g mask="url(#mask0_activity_log)">
                  <path
                    d="M8.89034 11.8518C9.81626 11.8518 10.6033 11.5277 11.2514 10.8796C11.8996 10.2314 12.2237 9.44437 12.2237 8.51845C12.2237 7.59252 11.8996 6.80548 11.2514 6.15734C10.6033 5.50919 9.81626 5.18511 8.89034 5.18511C7.96441 5.18511 7.17737 5.50919 6.52922 6.15734C5.88108 6.80548 5.557 7.59252 5.557 8.51845C5.557 9.44437 5.88108 10.2314 6.52922 10.8796C7.17737 11.5277 7.96441 11.8518 8.89034 11.8518ZM8.89034 10.5184C8.33478 10.5184 7.86256 10.324 7.47367 9.93511C7.08478 9.54622 6.89034 9.074 6.89034 8.51845C6.89034 7.96289 7.08478 7.49067 7.47367 7.10178C7.86256 6.71289 8.33478 6.51845 8.89034 6.51845C9.44589 6.51845 9.91811 6.71289 10.307 7.10178C10.6959 7.49067 10.8903 7.96289 10.8903 8.51845C10.8903 9.074 10.6959 9.54622 10.307 9.93511C9.91811 10.324 9.44589 10.5184 8.89034 10.5184ZM8.89034 14.074C7.08787 14.074 5.44589 13.5709 3.96441 12.5647C2.48293 11.5586 1.40885 10.2098 0.742188 8.51845C1.40885 6.82709 2.48293 5.47832 3.96441 4.47215C5.44589 3.46598 7.08787 2.96289 8.89034 2.96289C10.6928 2.96289 12.3348 3.46598 13.8163 4.47215C15.2977 5.47832 16.3718 6.82709 17.0385 8.51845C16.3718 10.2098 15.2977 11.5586 13.8163 12.5647C12.3348 13.5709 10.6928 14.074 8.89034 14.074ZM8.89034 12.5925C10.2854 12.5925 11.5663 12.2252 12.7329 11.4907C13.8996 10.7561 14.7916 9.76536 15.4089 8.51845C14.7916 7.27153 13.8996 6.28079 12.7329 5.54622C11.5663 4.81166 10.2854 4.44437 8.89034 4.44437C7.49527 4.44437 6.21441 4.81166 5.04774 5.54622C3.88108 6.28079 2.9891 7.27153 2.37182 8.51845C2.9891 9.76536 3.88108 10.7561 5.04774 11.4907C6.21441 12.2252 7.49527 12.5925 8.89034 12.5925Z"
                    fill="#1C1B1F"></path>
                </g>
              </svg>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </div>
</div>

<!-- Filter Modal -->
<nz-modal nzClassName="luqta-custom-modal" [(nzVisible)]="filterModalVisible"
  [nzTitle]="'Filter Activity Logs'" [nzFooter]="modalFooter" (nzOnCancel)="closeFilterModal()" nzWidth="650px">
  <ng-container *nzModalContent>
    <div class="row gy-3">
      <!-- Category -->
      <div class="col-md-6">
        <label class="form-label" style="font-size: 13px; font-weight: 500; color: #2e3b55; margin-bottom: 6px; display: block;">
          {{ 'activity-logs.category' | translate }}
        </label>
        <nz-select [(ngModel)]="tempCategory" [nzPlaceHolder]="'activity-logs.all-categories' | translate" nzAllowClear style="width: 100%;">
          <nz-option *ngFor="let opt of categoryOptions" [nzValue]="opt.value" [nzLabel]="opt.label | translate"></nz-option>
        </nz-select>
      </div>

      <!-- Action -->
      <div class="col-md-6">
        <label class="form-label" style="font-size: 13px; font-weight: 500; color: #2e3b55; margin-bottom: 6px; display: block;">
          {{ 'activity-logs.action' | translate }}
        </label>
        <nz-select [(ngModel)]="tempAction" [nzPlaceHolder]="'activity-logs.all-actions' | translate" nzAllowClear style="width: 100%;">
          <nz-option *ngFor="let opt of actionOptions" [nzValue]="opt.value" [nzLabel]="opt.label | translate"></nz-option>
        </nz-select>
      </div>

      <!-- Severity -->
      <div class="col-md-6">
        <label class="form-label" style="font-size: 13px; font-weight: 500; color: #2e3b55; margin-bottom: 6px; display: block;">
          {{ 'activity-logs.severity' | translate }}
        </label>
        <nz-select [(ngModel)]="tempSeverity" [nzPlaceHolder]="'activity-logs.all-severities' | translate" nzAllowClear style="width: 100%;">
          <nz-option *ngFor="let opt of severityOptions" [nzValue]="opt.value" [nzLabel]="opt.label | translate"></nz-option>
        </nz-select>
      </div>

      <!-- Date From -->
      <div class="col-md-6">
        <label class="form-label" style="font-size: 13px; font-weight: 500; color: #2e3b55; margin-bottom: 6px; display: block;">
          {{ 'activity-logs.date-from' | translate }}
        </label>
        <nz-date-picker class="custom-select w-100" [(ngModel)]="tempDateFrom"
          [nzPlaceHolder]="'activity-logs.select-date' | translate" nzFormat="dd/MM/yyyy"></nz-date-picker>
      </div>

      <!-- Date To -->
      <div class="col-md-6">
        <label class="form-label" style="font-size: 13px; font-weight: 500; color: #2e3b55; margin-bottom: 6px; display: block;">
          {{ 'activity-logs.date-to' | translate }}
        </label>
        <nz-date-picker class="custom-select w-100" [(ngModel)]="tempDateTo"
          [nzPlaceHolder]="'activity-logs.select-date' | translate" nzFormat="dd/MM/yyyy"></nz-date-picker>
      </div>
    </div>
  </ng-container>

  <ng-template #modalFooter>
    <div class="d-flex justify-content-between align-items-center w-100">
      <button type="button" class="btn" (click)="resetFiltersInModal()" style="background-color: #1f2430; color: #ffffff; border: none; border-radius: 8px; padding: 10px 22px; font-weight: 500;">
        Reset Filters
      </button>
      <button nz-button nzType="primary" class="btn btn-primary" (click)="applyFiltersFromModal()">
        Apply Filters
      </button>
    </div>
  </ng-template>
</nz-modal>

<!-- Detail Drawer -->
<ng-template #logDetailTitle>
  <div class="drawer-title">
    <i class="fa-solid fa-file-lines"></i>
    {{ 'activity-logs.log-details' | translate }}
  </div>
</ng-template>
<nz-drawer [nzVisible]="drawerVisible" [nzClosable]="true" [nzWidth]="540" nzPlacement="right"
  [nzTitle]="logDetailTitle" (nzOnClose)="closeDrawer()">
  <ng-container *nzDrawerContent>
    <div class="log-detail-content" *ngIf="selectedLog">

      <!-- Summary Card -->
      <div class="detail-summary-card">
        <div class="summary-header">
          <span class="category-badge" [ngClass]="getCategoryClass(selectedLog.category)">
            {{ getCategoryLabel(selectedLog.category) }}
          </span>
          <span class="severity-badge" [ngClass]="getSeverityClass(selectedLog.severity)">
            {{ getSeverityLabel(selectedLog.severity) }}
          </span>
        </div>
        <h3 class="summary-description">{{ selectedLog.description }}</h3>
        <span class="summary-time">
          <i class="fa-regular fa-clock me-1"></i>
          {{ formatDateTime(selectedLog.created_at) }}
        </span>
      </div>

      <!-- User Info Card -->
      <div class="detail-card">
        <div class="detail-card-header">
          <i class="fa-solid fa-user"></i>
          <h4>{{ 'activity-logs.user-information' | translate }}</h4>
        </div>
        <div class="detail-card-body">
          <div class="info-row">
            <span class="info-label">{{ 'activity-logs.user' | translate }}</span>
            <span class="info-value">{{ selectedLog.user_name || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'activity-logs.email' | translate }}</span>
            <span class="info-value">{{ selectedLog.user_email || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'activity-logs.role' | translate }}</span>
            <span class="info-value text-capitalize">{{ selectedLog.user_role || '-' }}</span>
          </div>
        </div>
      </div>

      <!-- Event Details Card -->
      <div class="detail-card">
        <div class="detail-card-header">
          <i class="fa-solid fa-info-circle"></i>
          <h4>{{ 'activity-logs.event-details' | translate }}</h4>
        </div>
        <div class="detail-card-body">
          <div class="info-row">
            <span class="info-label">{{ 'activity-logs.category' | translate }}</span>
            <span class="info-value">{{ getCategoryLabel(selectedLog.category) }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'activity-logs.action' | translate }}</span>
            <span class="info-value">{{ getActionLabel(selectedLog.action) }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'activity-logs.severity' | translate }}</span>
            <span class="info-value">{{ getSeverityLabel(selectedLog.severity) }}</span>
          </div>
          <div class="info-row" *ngIf="selectedLog.content_type">
            <span class="info-label">{{ 'activity-logs.content-type' | translate }}</span>
            <span class="info-value text-capitalize">{{ selectedLog.content_type }}</span>
          </div>
          <div class="info-row" *ngIf="selectedLog.content_title">
            <span class="info-label">{{ 'activity-logs.content-title' | translate }}</span>
            <span class="info-value">{{ selectedLog.content_title }}</span>
          </div>
        </div>
      </div>

      <!-- Changes Card (if changes exist) -->
      <div class="detail-card" *ngIf="changesList.length > 0">
        <div class="detail-card-header">
          <i class="fa-solid fa-code-compare"></i>
          <h4>{{ 'activity-logs.changes' | translate }}</h4>
        </div>
        <div class="detail-card-body no-padding">
          <div class="changes-table">
            <div class="changes-header">
              <span>{{ 'activity-logs.field' | translate }}</span>
              <span>{{ 'activity-logs.old-value' | translate }}</span>
              <span>{{ 'activity-logs.new-value' | translate }}</span>
            </div>
            <div class="changes-row" *ngFor="let change of changesList">
              <span class="change-field">{{ change.field }}</span>
              <span class="change-old">{{ change.old_value }}</span>
              <span class="change-new">{{ change.new_value }}</span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </ng-container>
</nz-drawer>
